import React from 'react'
import { formatDecimalHoursToHM } from '../../utils/formatDecimalHoursToHM'
import { TfiTime } from 'react-icons/tfi'
import { IoSettingsOutline } from 'react-icons/io5'

export const StampGroupRow = (
  {
    groupData
  }
) => {
  const {
    groupName,
    groupTotalQuantity,
    groupTotalStamps,
    groupTotalStampsByHourlyRate,
    groupTotalPrepareTime,
    groupPrepareOperationsCount
  } = groupData



  const formatHours = formatDecimalHoursToHM(groupTotalStampsByHourlyRate)
  const totalPrepareTime = formatDecimalHoursToHM(groupTotalPrepareTime)
  return (
    <div className={`grid grid-cols-[72rem_1fr_1fr] mt-[1px] text-center font-medium text-Regular(14_16) gap-[1px]`}>
      <div className='py-[2.2rem] bg-[#E1CCE7] text-left pl-[2rem]'>
        {groupName}
      </div>
      <div className={`py-[2.2rem] bg-[#FFFFFF] grid grid-cols-[1fr_2fr] gap-[3rem]`}>
        <div className={`flex justify-end`}>
          {groupTotalQuantity ? groupTotalStamps.toLocaleString() : '-'}
        </div>
        {formatHours && <div className={`flex items-center gap-[2rem]`}>
          <div className={`flex items-center gap-[0.4rem]`}>
            <TfiTime /> {formatHours}
          </div>
          {(groupTotalQuantity && totalPrepareTime) ? <div className={`flex items-center gap-[0.4rem]`}>
            <IoSettingsOutline /> {totalPrepareTime} ({groupPrepareOperationsCount} настр.)
          </div>
            : <div className={`flex items-center gap-[0.4rem]`}>-</div>
          }
        </div>
        }
      </div>
      <div className={`py-[2.2rem] bg-[#FFFFFF]`}>{groupTotalQuantity ? groupTotalQuantity.toLocaleString() : '-'}</div>
    </div>
  )
}